import ChevronIcon from './ChevronIcon';

export default ChevronIcon;
